import React, { useState } from "react";
import { IoMdEye } from "react-icons/io";
import { RiDeleteBin6Line } from "react-icons/ri";
import { Link, useNavigate } from "react-router-dom";
import { IoIosArrowRoundBack } from "react-icons/io";
import { MdOutlineEdit } from "react-icons/md";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getAllHotels } from "../../../api/admin/hotelManagement";
import Pagination from "../../../components/common/Pagination";
import { FiEdit } from "react-icons/fi";
import { useSettings } from "../../../context/SettingsContext";
import { Settings } from "lucide-react";
import { updateSettings } from "../../../api/admin/settinngs";
import toast from "react-hot-toast";
import Swal from "sweetalert2";
import { useTranslation } from "../../../hooks/useTranslation";

const HotelManagement = () => {
  const { t } = useTranslation();
  const [enabled, setEnabled] = useState(true);
  const queryClient = useQueryClient();
  const [page, setPage] = useState(1);
  const limit = 10;
  const navigate = useNavigate();
  const { settings } = useSettings();
  const showHotels = settings?.showHotels;

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["restaurants", page],
    queryFn: () => getAllHotels({ page, limit }),
    keepPreviousData: true,
  });

  const upadteSettingsMutation = useMutation({
    mutationFn: updateSettings,
    onSuccess: () => {
      toast.success(t("hotelManagement").toastUpdateSuccess);
      queryClient.invalidateQueries(["applicationSettings"]);
    },
    onError: () => {
      toast.error(t("hotelManagement").toastUpdateFail);
    },
  });

  const hotelManagement = data?.data?.hotels || [];
  const pagination = data?.data?.pagination || {};

  const handleToggle = (showHotels) => {
    Swal.fire({
      title: t("hotelManagement").toggleConfirmTitle,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: t("hotelManagement").toggleConfirmYes,
      cancelButtonText: t("hotelManagement").toggleConfirmNo,
    }).then((result) => {
      if (result.isConfirmed) {
        upadteSettingsMutation.mutate({
          showHotels: !showHotels,
        });
      }
    });
  };

  return (
    <>
      <div className="flex gap-[10px] items-center justify-between flex-wrap">
        <div className="flex gap-[10px] items-center">
          <div
            onClick={() => navigate(-1)}
            className="w-[32px] h-[32px] bg-[#4CAF50] rounded-[50%] flex items-center justify-center hover:bg-[#FF9D00]"
          >
            <IoIosArrowRoundBack size={24} className="text-[#fff]" />
          </div>
          <h2 className="text-[22px] font-medium">
            {t("hotelManagement").title}
          </h2>
        </div>

        <div className="flex gap-[10px] items-center justify-end">
          <h2 className="md:text-[22px] text-base font-medium">{t("hotelManagement").showHotels}</h2>
          {/* toggle for showing hotels */}
          <div
            onClick={() => handleToggle(showHotels)}
            className={`w-[48px] h-[20px] mx-auto flex items-center rounded-full p-1 cursor-pointer transition-colors ${
              showHotels ? "bg-[#4CAF50]" : "bg-[#e1e1e1]"
            }`}
          >
            <div
              className={`bg-white w-[16px] h-[16px] rounded-full shadow-md transform transition-transform ${
                showHotels ? "translate-x-6" : "translate-x-0"
              }`}
            />
          </div>
        </div>
      </div>
      <div className="mt-[31px]">
        <div className="rounded-[10px] border border-[#D9D9D9] overflow-hidden mt-[28px] py-[20px] sm:px-[30px] px-[15px] bg-white">
          <h2 className="text-base font-semibold">
            {t("hotelManagement").approveNewHotels}
          </h2>

          <div className="overflow-x-auto md:mt-[30px] mt-[30px]">
            <table className="min-w-full  ">
              <thead className="bg-[#FFFAF2] ">
                <tr className="">
                  <th className="text-left text-sm font-medium text-[#000000] py-[12px] px-[16px] whitespace-nowrap">
                    {t("hotelManagement").hotelName}
                  </th>
                  <th className="text-left text-sm font-medium text-[#000000] py-[12px] px-[16px] whitespace-nowrap">
                    {t("hotelManagement").category}
                  </th>
                  <th className="text-left text-sm font-medium text-[#000000] py-[12px] px-[16px] whitespace-nowrap">
                    {t("hotelManagement").status}
                  </th>
                  <th className="text-left text-sm font-medium text-[#000000] py-[12px] px-[16px] whitespace-nowrap">
                    {t("hotelManagement").platformFee}
                  </th>

                  <th className="text-left text-sm font-medium text-[#000000] py-[12px] px-[16px] whitespace-nowrap">
                    {t("hotelManagement").actions}
                  </th>
                </tr>
              </thead>
              <tbody>
                {/* <!-- Row 1 --> */}
                {hotelManagement?.map((hotelItem) => {
                  const { _id, name, verificationStatus, platformFee } =
                    hotelItem || {};
                  return (
                    <tr className="border-t border-[#E4E4E4] ">
                      <td className="py-[12px] px-[16px] text-[14px] font-normal text-black">
                        {name}
                      </td>
                      <td className="py-[12px] px-[16px] text-[14px] font-normal text-black  whitespace-nowrap">
                        {t("hotelManagement").categoryHotel}
                      </td>
                      <td className="py-[12px] px-[16px] text-[14px] font-normal text-black  whitespace-nowrap">
                        <div
                          className={`p-[2px_8px_2px_8px] rounded-full w-fit  text-center text-sm  text-white ${
                            verificationStatus === "approved"
                              ? "bg-[#4CAF50]"
                              : verificationStatus === "rejected"
                              ? "bg-[#FF0000]"
                              : "bg-[#FF9D00]"
                          }`}
                        >
                          {/* {verificationStatus} */}
                          {verificationStatus.charAt(0).toUpperCase() +
                            verificationStatus.slice(1)}
                        </div>
                      </td>

                      <td className="py-[12px] px-[16px] text-[17px] text-black whitespace-nowrap flex items-center gap-3">
                        {platformFee != null && platformFee !== "" ? `${platformFee}%` : "-"}
                      </td>

                      <td className="py-[12px] px-[16px] ">
                        <Link
                          to={`/hoteldetailpage/${_id}`}
                          className="text-black font-normal w-[32px] h-[32px] flex items-center justify-center rounded-full bg-[#F2F2F2] "
                        >
                          <IoMdEye className="text-base text-black" />
                        </Link>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <Pagination
            page={pagination.page}
            totalPages={pagination.totalPages}
            setPage={setPage}
          />
        </div>
      </div>
    </>
  );
};

export default HotelManagement;
